<div mat-dialog-title class="ds">
  <span>{{ appStrings.leads_validateLeadTitle }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

@if (loading) {
  <div id="loadingContainer" class="overlay full">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<div mat-dialog-content class="content ds">
  <div class="dialog-body">
    <div class="lead-info">
      <div class="row">
        <typography id="name_label" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.accounts_labelName }} </typography>
        <typography id="name" class="details" variant="mat-body-1" weight="medium"> {{ element.record.name1 }} </typography>
      </div>
    </div>
    <form id="email-form" class="email-form" [formGroup]="selectForm">
      <ds-textfield id="customer-email" class="fill-width no-subscript"
        [label]="appStrings.leads_validateEmail_label"
        label_orientation="vertical-label"
        [control]="selectForm.controls.email">
      </ds-textfield>
    </form>
    <ds-alert alert_type="info" [alert_message]="appStrings.leads_validateEmailText"></ds-alert>
  </div>
</div>

<div mat-dialog-actions align="end" class="ds dialog-actions">
  <div class="dialog-btn-wrapper">
    <ds-button id="close-button" variant="label-only" size="medium"
      type="tertiary" (onClick)="close()"
      [label]="appStrings.button_close">
    </ds-button>
    <ds-button id="send-email-button" variant="label-only" size="medium"
      type="primary"
      (onClick)="sendAccountEmailDetails(element.record.leadId)"
      [label]="appStrings.button_send"
      [isDisabled]="selectForm.invalid">
    </ds-button>
  </div>
</div>
